module.exports = __webpack_public_path__ + "media/images/image_mdc-3e1a64001b30d0a224c7e1bbf19e2055.jpg";